import { Spinner } from '@fluentui/react-components';
import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

const LogoutPage = lazy(() => import('../pages/LogoutPage').then((m) => ({ default: m.LogoutPage })));

export const Route = createFileRoute('/logout')({
  component: () => (
    <Suspense fallback={<Spinner style={{ position: 'absolute', top: '25%', left: '50%' }} />}>
      <LogoutPage />
    </Suspense>
  ),
});
